module.exports = __webpack_public_path__ + "static/recycledcomforters-7254f23516f6e40421196b68047631e5.png";